import type { TableFilterDropdownOptions } from "../table-filter.type";
import type { TableFilterQueryableProps } from "./table-filter-queryable.type";

import TableFilterIconSearch from "../table-filter-icon-search";

import TableFilterQueryableSelect from "./table-filter-queryable.component";

export const getTableFilterQueryable = (
  selectProps: TableFilterQueryableProps
): TableFilterDropdownOptions => ({
  filterIcon: TableFilterIconSearch,
  filterDropdown: (dropdownProps) => (
    <TableFilterQueryableSelect {...selectProps} {...dropdownProps} />
  ),
});
